import React from 'react';
import { useEditorActions, useHistoryInfo } from '../store/editorStore.jsx';

/**
 * Toolbar – undo/redo buttons + optional extra actions.
 *
 * Props:
 *   onSave  {Function} – called when the user clicks Save
 *   onClose {Function} – optional cancel/close handler
 *   title   {string}   – optional title shown in the toolbar
 */
export function Toolbar({ onSave, onClose, title }) {
  const { undo, redo } = useEditorActions();
  const { canUndo, canRedo } = useHistoryInfo();

  return (
    <div
      className="editor-toolbar d-flex align-items-center gap-2 px-3 py-2 border-bottom"
      style={{ background: '#fff', flexShrink: 0 }}
    >
      {title && (
        <span className="fw-semibold me-2 text-truncate" style={{ maxWidth: 220 }}>
          {title}
        </span>
      )}

      <div className="d-flex gap-1">
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          title="Undo (Ctrl+Z)"
          disabled={!canUndo}
          onClick={undo}
        >
          ↩ Undo
        </button>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          title="Redo (Ctrl+Y)"
          disabled={!canRedo}
          onClick={redo}
        >
          ↪ Redo
        </button>
      </div>

      <div className="ms-auto d-flex gap-2">
        {onClose && (
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onClose}>
            Cancel
          </button>
        )}
        {onSave && (
          <button type="button" className="btn btn-sm btn-primary" onClick={onSave}>
            Save Content
          </button>
        )}
      </div>
    </div>
  );
}
